import { Component, model, Input } from "@angular/core";
import { TransactionDirection } from "@bitwarden/web-vault/app/models/enum/transactionDirection";

@Component({
  selector: "app-auto-transaction-direction",
  templateUrl: "./auto-complete-transaction-direction.component.html",
})
export class AutoCompleteTransactionDirectionComponent {
  readonly directions = Object.values(TransactionDirection);
  protected readonly TransactionDirection = TransactionDirection;
  direction = model<TransactionDirection>(this.directions[0]);

  @Input() label!: string;
  @Input() labelClass?: string;
  @Input() isRequired?: boolean;

  private isValidDirection(direction: string): direction is TransactionDirection {
    return this.directions.includes(direction as TransactionDirection);
  }

  onDirectionChange(direction: string): void {
    if (this.isValidDirection(direction)) {
      this.direction.set(direction);
    }
  }
}
